<template>
  <div>
    
    <div class="flex items-center justify-between" style="height: 40px">
      <div class="h-full flex items-center">
        <el-dropdown>
          <button
            class="sort-button flex items-center justify-center rounded-md h-full mr-3"
            :class="{ 'shadow-sm': sortList }"
            style="width: 40px; height: 40px; background-color: #f7fafd"
          >
            <sort-icon />
          </button>
          <el-dropdown-menu slot="dropdown" placement="right-end">
            <el-dropdown-item disabled>SORT BY</el-dropdown-item>

            <el-dropdown-item>
              <button @click="setSortOrder('ASC')" class="flex items-center">ASC</button>
            </el-dropdown-item>
            <el-dropdown-item>
              <button @click="setSortOrder('DESC')" class="flex items-center">
                DESC
              </button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div class="flex items-center mr-8">
          <div class="table__search-input-wrapper">
            <span class="pr-2">
              <search-icon />
            </span>

            <input
              type="text"
              class="table__search-input"
              placeholder="Search..."
              v-model="queryString"
            />

            <search-drop-down-icon />
          </div>
        </div>

      </div>

      <div class="date-picker flex items-center justify-center">
        <el-date-picker
          type="date"
          placeholder="Start Date"
          style="margin: 0"
          class="mr-3"
          v-model="startDate"
        />

        <el-date-picker
          type="date"
          placeholder="End Date"
          style="margin: 0"
          v-model="endDate"
        />
      </div>
    </div>

    <div
      class="mt-5 table-header flex flex-nowrap bg-[#E5E5E5] text-md justify-around p-4 pl-11 border-y-1 border-[#D9D5EC] overflow-wrap text-[#383F51]"
    >
      <p class="w-1/12"><input type="checkbox" class="checkbox mt-1" /></p>
      <p class="w-3/12 ml-2 text-[#383F51]" v-for="header in activeHeaders" :key="header">{{ header.name }}</p>
      <!-- <p class="w-3/12 text-[#383F51]">DISPATCH REF.</p>
      <p class="w-3/12 ml-2">FLEET NAME</p>
      <p class="w-5/12 ml-2">FLEET REG NO.</p>
      <p class="w-3/12 ml-2">DRIVER</p>
      <p class="w-3/12 ml-2">ORIGIN</p>
      <p class="w-3/12 ml-2">DESTINATION</p>
      <p class="w-3/12 ml-2">LOAD CAPACITY</p>
      <p class="w-4/12 ml-2">FLEET STATUS</p> -->
      <div class="w-1/12 overflow-x-auto text-xs text-right cursor-pointer"
      @click="showFilterModal = true">
        <img
          src="../../../../assets/images/icons/options-icon.png"
          class="inline-block"
        />
      </div>
    </div>
    <div
      class="py-5 bg-white w-100 flex items-center justify-center mt-5"
      style="height: 60vh"
      v-if="loadingDispatches"
    >
      <loader />
    </div>
    <div v-else>
      <div v-if="dispatches.length > 0">
        <TablerowBase
          class="mt-3"
          v-for="dispatch in paginatedList"
          :key="dispatch.id"
          :shippingServices="shippingServices"
          @refetch-dispatch="getDisp()"
          :dispatch="dispatch"
          :currentTab="currentTab"
          :locations="locations"
          :activeHeaders="activeHeaders"
        />
      </div>
      <div v-else>
        <div class="flex flex-col items-center gap-2 justify-center p-5 bg-white w-100">
          <empty-booking-icon />
          <p>No Dispatches Currently</p>
        </div>
      </div>
    </div>

    <put-on-hold-modal
      :fleetId="selectedFleetId"
      @dispatch-paused="getAllFleets"
      :showModal="showHoldModal"
      @close-modal="showHoldModal = false"
    />

    <pagination-control
      :total="totalDispatch"
      :pageNumber="pageNumber"
      @pageNumber="setNumDisplayDispatch"
      @pageSize="pageSizeSet"
    />

    <DispatchTableFilter :show-modal="showFilterModal" :activeHeaders="activeHeaders"
    @close-modal="showFilterModal = false" />


  </div>
</template>

<script>
import PaginationControl from "@/components/UI/pagination";
import TablerowBase from "./TablerowBase";
import PutOnHoldModal from "@/components/3pl/Operations/Dispatch/Modals/PutOnHoldModal.vue";
import moment from "moment";
import DispatchTableFilter from "./Modals/DispatchTableFilter.vue";


export default {
  props: ["currentTab"],
  components: {
    DispatchTableFilter,
    PaginationControl,
    TablerowBase,
    PutOnHoldModal,
  },
  data() {
    return {
      showFilterModal: false,
      selectedFleetId: null,
      fleets: [],
      removedTableData: [],
      isLoading: false,
      isTableFilter: false,
      showHoldModal: false,
      date: 0,
      location: "null",
      queryString: null,
      sortList: false,
      startDate: "",
      endDate: "",
      shippingServices: [],
      dispatches: [],
      loadingDispatches: true,
      sortOrder: "ASC",
      pageSize: 10,
      sortColumn: "",
      totalDispatch: 1,
      dispatchPerPage: 10,
      pageNumber: 1,
      locations : [],
      activeHeaders: [
        { name: "DISPATCH REF." },
        { name: "FLEET NAME" },
        { name: "FLEET REG NO." },
        { name: "DRIVER" },
        { name: "ORIGIN" },
        { name: "DESTINATION" },
        { name: "LOAD CAPACITY" },
        { name: "FLEET STATUS" },
      ],
    };
  },
  computed: {
    dispatchReadyFleets() {
      let fleetsWithShippingServices = this.fleets.filter((fleet) => {
        return fleet.shippingService;
      });

      return fleetsWithShippingServices;
    },
    dispatchesList() {
      return this.dispatches;
    },
    startRange() {
      return (this.pageNumber - 1) * Number(this.dispatchPerPage);
    },
    endRange() {
      return this.pageNumber * Number(this.dispatchPerPage);
    },
    paginatedList() {
      return this.dispatches.filter(
        (item, index) => index >= this.startRange && index < this.endRange
      );
    },
    setparams() {
      return { pageSize: this.dispatchPerPage, pageNum: this.pageNumber };
    },
    locationId() {
      return this.$store.getters.currentLocationId;
    }
  },
  watch: {
    currentTab() {
      this.getDispatches({ dispatchType : this.currentTab, terminalId: this.locationId });
    },
    setparams() {
      this.loading = true;
      this.getDispatches({ dispatchType : this.currentTab });
    },
    queryString() {
      this.getDispatches({
        dispatchType : this.currentTab,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.queryString,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
        terminalId: this.locationId,
      });
    },
    sortColumn() {
      this.getDispatches({
        dispatchType : this.currentTab,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
        terminalId: this.locationId,
      });
    },
    locationId() {
      this.getDispatches({
        dispatchType : this.currentTab,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
        terminalId: this.locationId,
      });
    },
    sortOrder() {
      this.getDispatches({
        dispatchType : this.currentTab,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
        terminalId: this.locationId,
      });
    },
    pageSize() {
      this.getDispatches({
        dispatchType : this.currentTab,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "",
        endDate: this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "",
        search: this.query,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
        terminalId: this.locationId,
      });
    },
    startDate() {
      if (this.startDate && this.endDate) {
        this.getDispatches({
          dispatchType : this.currentTab,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
          sortOrder: this.sortOrder,
          pageSize: this.pageSize,
          sortColumn: this.sortColumn,
          terminalId: this.locationId,
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getDispatches({
          dispatchType : this.currentTab,
          sortOrder: this.sortOrder,
          sortColumn: this.sortColumn,
          terminalId: this.locationId,
        });
      }
    },

    endDate() {
      if (this.startDate && this.endDate) {
        this.getDispatches({
          dispatchType : this.currentTab,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
          sortOrder: this.sortOrder,
          sortColumn: this.sortColumn,
          terminalId: this.locationId,
        });
      }

      if (!this.startDate && !this.endDate) {
        this.getDispatches({
          dispatchType : this.currentTab,
          sortOrder: this.sortOrder,
          sortColumn: this.sortColumn,
          terminalId: this.locationId,
        });
      }
    },
  },
  mounted() {
    this.getAllFleets();
    this.getDispatches({ dispatchType : this.currentTab, terminalId: this.locationId });
    this.getAllLocations();
  },

  methods: {
    getDisp(){
      this.getDispatches({ dispatchType : this.currentTab, terminalId: this.locationId });
    
    },
    setSortOrder(val) {
      this.sortOrder = val;
    },
    pageSizeSet(val) {
      this.dispatchPerPage = val;
    },
    setNumDisplayDispatch(val) {
      this.pageNumber = val;
    },
    updateTableData(data) {
      let index = this.removedTableData.indexOf(data);
      if (index >= 0) {
        this.removedTableData.splice(index, 1);
      } else {
        this.removedTableData.push(data);
      }
      this.isTableFilter = false;
      this.scrollLeft();
    },
    scrollLeft() {
      let container = document.getElementById("table-wrapper");
      container.scrollLeft += 10000;
    },
    viewManifest(fleet) {
      localStorage.setItem("selectedFleet", JSON.stringify(fleet));
      this.$router.push({ name: "DispatchManifest" });
    },
    toggleActions(id) {
      if (this.showActions) {
        this.showActions = null;
      } else {
        this.selectedFleetId = id;
      }
    },
    getAllLocations() {
        try {
            this.$_getAllLocations().then((response) => {
                this.locations = response.data.data.locations;
                this.$store.dispatch("saveOrgLocations", response.data.data.locations)
            });
        } catch (error) {
            this.handleError(error);
        }
    },
    async getAllFleets() {
      try {
        const response = await this.$_getAllFleets();
        this.fleets = response.data.data.allFleets;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getDispatches({
      dispatchType ,
      startDate,
      endDate,
      sortOrder,
      search,
      pageSize,
      sortColumn,
      terminalId
    }) {
      this.loadingDispatches = true;
      try {
        let response = {};
        let payload = {
            dispatchType ,
            startDate,
            endDate,
            sortOrder,
            search,
            pageSize,
            sortColumn,
            terminalId
        }

        if(payload.terminalId == undefined){
          // delete payload.dispatchType
          delete payload.terminalId
        }
        response = await this.$_getDispatches(payload);

        this.dispatches = response.data.dispatches;
        this.totalDispatch = response.data.totalCount;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loadingDispatches = false;
      }
    },
    async dispatchFleet() {
      this.generateToast("Dispatching fleet", "success");
      try {
        await this.$_dispatchFleet(this.selectedFleetId);
        this.getAllFleets();
        this.generateToast("Fleets successfully dispatched!", "success");
      } catch (error) {
        this.handleError(error);
      }
    },
    perPageSize(pageSize) {
      this.pageSize = pageSize;
    },
    
  },
};
</script>

<style lang="scss" scoped>
th {
  color: #707684;
}
td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 1rem 0.75rem;
  vertical-align: top;
  font-size: 0.9rem;
  span {
    display: block;
  }
  span:last-of-type {
    font-weight: normal;
    color: #10233e;
    opacity: 0.6;
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}

.table-header {
  border-bottom: 1px solid #e1e3ea;
  p {
    color: #383f51;
    opacity: 0.5;
  }
}
.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
  border: 1px solid #dae8f6;
  border-radius: 5px;
  height: 40px;
}
.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}
table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  padding: 0.75rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 10rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }
  > div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
</style>
